module.exports = __webpack_public_path__ + "static/64invgde-b72fcd93acc695a42d7e46e56b54c00c.gif";